import { usePage } from '@inertiajs/react';
import type { ReactNode } from 'react';
import type { SharedProps, VoteEdition } from '@/types';
import { VoteFooter } from './VoteFooter';
import { VoteHeader } from './VoteHeader';

type VoteLayoutProps = SharedProps & {
  edition: VoteEdition;
  hasGoogleAccount: boolean;
};

// The `layout.tsx` every /:edition/vote page sits inside. The 26 editions add the
// `theme-ph26` palette and the sans stack; 25 keeps the original.
//
// Everything it needs is read off `usePage()` rather than taken as props: Inertia calls
// a page's `layout` function with the raw props first and with the rendered child
// second, so a layout that reads its arguments would get `undefined` on the second call.
export function VoteLayout({ children }: { children: ReactNode }) {
  const { auth, edition, hasGoogleAccount } = usePage<VoteLayoutProps>().props;

  return (
    <div
      className={
        edition.variant === '25'
          ? 'flex min-h-screen w-full flex-col bg-background'
          : 'theme-ph26 flex min-h-screen w-full flex-col bg-background font-sans text-foreground'
      }
    >
      <VoteHeader
        edition={edition}
        user={auth.user}
        hasGoogleAccount={hasGoogleAccount}
      />
      <div className="flex-1">{children}</div>
      <VoteFooter edition={edition} />
    </div>
  );
}
